import { render, staticRenderFns } from "./ProductoPreciosListaPanel.vue?vue&type=template&id=b43d9432&"
import script from "./ProductoPreciosListaPanel.vue?vue&type=script&lang=js&"
export * from "./ProductoPreciosListaPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports